import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import Auth from "./pages/Auth";
import Waitlist from "./pages/Waitlist";
import Dashboard from "./pages/Dashboard";
import ProfileSetup from "./pages/ProfileSetup";
import PortfolioDetail from "./pages/PortfolioDetail";
import NotFound from "./pages/NotFound";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfUse from "./pages/TermsOfUse";
import CreditsReferrals from "./pages/CreditsReferrals";
import KiteCallback from "./pages/KiteCallback";
import BlogPage from "./pages/BlogPage";
import BlogPostPage from "./pages/BlogPostPage"; // New component for individual posts
import ComingSoon from "./pages/ComingSoon";
import AboutUs from "./pages/AboutUs";
import Careers from "./pages/Careers";
import WaitlistAdmin from "./pages/WaitlistAdmin";
import { AuthProvider } from "./hooks/useAuth";
import ProtectedRoute from "./components/ProtectedRoute";
import ScrollToTop from "./components/ScrollToTop";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000,
    },
  },
});

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <ScrollToTop />
          <AuthProvider>
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/auth" element={<Auth />} />
              <Route path="/waitlist" element={<Waitlist />} />
              <Route path="/kite-callback" element={<KiteCallback />} />
              <Route path="/top-5-news" element={<BlogPage />} />
              <Route path="/top-5-news/:blogId" element={<BlogPostPage />} /> {/* New route for individual posts */}
              <Route path="/coming-soon" element={<ComingSoon />} />

              <Route path="/dashboard" element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              } />
              <Route path="/profile-setup" element={
                <ProtectedRoute>
                  <ProfileSetup />
                </ProtectedRoute>
              } />
              <Route path="/portfolio/:id" element={
                <ProtectedRoute>
                  <PortfolioDetail />
                </ProtectedRoute>
              } />
              <Route path="/credits-referrals" element={
                <ProtectedRoute>
                  <CreditsReferrals />
                </ProtectedRoute>
              } />
              <Route path="/admin/waitlist" element={
                <ProtectedRoute>
                  <WaitlistAdmin />
                </ProtectedRoute>
              } />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-of-use" element={<TermsOfUse />} />
              <Route path="/about-us" element={<AboutUs />} />
              <Route path="/careers" element={<Careers />} />

              <Route path="*" element={<NotFound />} />
            </Routes>
          </AuthProvider>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;